// extracted by mini-css-extract-plugin
module.exports = {"container":"Category_container__3ZMhc","margin":"Category_margin__2i8pp","sheet":"Category_sheet__2B0ey","active":"Category_active__zUjLD","padding":"Category_padding__2jqIm"};